import { PlaybackPositionsResponse } from '../types/Player';
import { guardedLocalStorage } from './fnStorage';

export type PositionType = 'recording' | 'vod' | 'listing';

export function getBookmark(assetId: string, positionType: PositionType): number | undefined {
    const savedPositions = JSON.parse(guardedLocalStorage.getItem('playbackPositions') || '{}') as PlaybackPositionsResponse;

    switch (positionType) {
        case 'vod':
            return savedPositions.vod_asset_playback_positions?.[assetId];
        case 'listing':
        case 'recording':
            return savedPositions.listing_playback_positions?.[assetId];
        default:
            return undefined;
    }
}
